module.exports = __webpack_public_path__ + "img/DSC_2661-xl.d471f14f.png";